import { type FC } from 'react';

import styles from './Pixel.css';

export const Pixel: FC = () => {
  return <div className={styles['container']} data-testid="pixel" />;
};
